import {Component, EventEmitter, inject, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  WmsDialogBodyComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent,
  WmsWizardComponent,
  BaseComponent, TemplateConfigComponent, SelectDataSourceComponent
} from "@wms/components";
import {getServiceTypesByCollectionType, VARIABLE_CONSTANTS} from "@wms/variables";
import {cloneDeep, each, filter, find, forEach, get, includes, remove, replace, toUpper} from "lodash-es";
import {BindTreeUtilsService, ServiceFactoryService} from "@wms/services";
import {
  MarkupManagerService,
  specialCharactersToUnderscores,
  getUniqueWidgetName,
  processLiveWidgetTemplate, stringStartsWith
} from "@wms/core";
import {WidgetPropertiesProvider} from "@wms/design-container";
import {
  LiveListFieldConfigComponent
} from "@wms/app/components/live-list-field-config/live-list-field-config.component";
import { propFactory as PropertiesFactory } from '@wm/components-base';



@Component({
  selector: 'wms-carousel-widget-config',
  standalone: true,
  imports: [CommonModule, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsWizardComponent, TemplateConfigComponent, SelectDataSourceComponent, LiveListFieldConfigComponent],
  templateUrl: './wms-carousel-widget-config.component.html',
  styleUrls: ['./wms-carousel-widget-config.component.less']
})
export class WmsCarouselWidgetConfigComponent extends BaseComponent implements OnInit {
  @Input() widgetDetails!: any;
  @Input() widgetInfo!: any;
  @Input() widgetType?: any = '';
  @Output() handleClose = new EventEmitter<any>();
  @Output() handleComplete = new EventEmitter<any>();

  @ViewChild('emptyTemplate') emptyTemplate: TemplateRef<any>;
  @ViewChild('templateConfig') templateConfigStep: TemplateRef<any>;
  @ViewChild('liveListFieldConfig') liveListFieldConfigStep: TemplateRef<any>;
  stepCounter: number = -1;
  templateWidgets: any;
  fields: any;
  showWizard = true;
  steps: Array<any> = [];
  currentStep: any;
  activeInnerStep: any;
  hasBinding: boolean = false;
  selectedLiveWidgetLayout: any;
  liveWidgetNavigation: any;
  nextBtnText: string = this.locale.LABEL_NEXT;
  message!: any;
  stepDescription: string | undefined;
  activeLiveWidget!: any;
  alertMessages: any = undefined;
  isSourceMode = this.widgetType !== 'wm-carousel';
  gridOptions: { isEditable: any, canEdit: any } = {
    'isEditable': 'true',
    'canEdit': 'true'
  };
  widgetConfig = {
    'bindMode': 'variable',
    'widgetMode': 'EDITABLE',
    'formType': 'INLINE',
  };
  navigationList: any;
  liveWidgetLayouts: any;
  screens = ["layouts"];
  widgetFilter: any;
  variableFilter: any;
  widgetPropertiesProvider;
  formConfig: any;
  liveformConfig: any;
  widgetDefs: any = {};
  submitInProgress = false;
  markupManagerService;
  dataSource: any = [];
  selectedDataSource: any = {};
  listTemplate: any;
  showServiceSpinner: boolean = false;
  listImage: string;
  widgetList: any;
  widgetsAvailable: any;
  selectedWidget: any;
  variableList: any;
  metadataVariableList: any;
  showDesignButton: any;
  apiService: any;
  categoryFilterList: any;
  serviceTypes = getServiceTypesByCollectionType('data');
  operationText: any;
  treeData: any;
  webService: any;
  serviceFactory: any;
  widgetProperties: any;
  liveWidget: any;
  nodeType: string;
  activeNodeType: string;
  selectedNode: any;
  disableBind: boolean;
  selectedNodeProps: any;
  protected readonly undefined = undefined;
  private isNativeMobileApplicationType: boolean;

  constructor() {
    super()
    this.markupManagerService = inject(MarkupManagerService);
    this.widgetPropertiesProvider = inject(WidgetPropertiesProvider);
    this.serviceFactory = inject(ServiceFactoryService);
    this.isNativeMobileApplicationType = this.projectService.isNativeMobileApplicationType();
  }

  ngAfterViewInit() {
    // Adding settimeout so that the ng-templates for different steps are loaded by then in the view child
    setTimeout(() => this.incrementStep(), 0);

  }

  ngOnInit(): void {
    const {requireVariable, screens} = this.widgetInfo;
    this.steps = [...screens];

    this.showServiceSpinner = true;
    this.widgetProperties =PropertiesFactory.getPropertiesOf(this.liveWidget);
  }

  getStepTemplate() {
    switch (this.currentStep?.screen) {
      case 'templateConfig':
        return this.templateConfigStep;
      case 'liveListFieldConfig':
        return this.liveListFieldConfigStep;
      default:
        return this.emptyTemplate;
    }
  }

  incrementStep(): void {
    if (this.currentStep && this.currentStep.screen === 'templateConfig') {
      if (this.activeInnerStep !=='pagination') {
        this.stepCounter += 1;
        this.onStepChange(this.stepCounter);
      } else if (this.activeInnerStep !== 'pagination') {
        if (!this.isNativeMobileApplicationType && includes(['wm-table', 'wm-list', 'wm-card'], this.activeLiveWidget)) {
          this.selectStep('pagination');
          return;
        }
      } else {
        this.selectStep('layout');
      }
    } else {
      this.stepCounter += 1;
      this.onStepChange(this.stepCounter);
    }
  }


  selectStep(innerStepName: any) {
    this.activeInnerStep = innerStepName;
  }

  selectWidgetLayout(layout: any) {
    layout.active = true;
    //For live widget we keep track of selected layout within currentStep
    if (!((this.widgetType === 'wm-livetable' && this.stepCounter > 0) || (this.widgetType === 'wm-table' && this.stepCounter > 1))) {
      this.widgetDetails.activeLayout = layout;
    }
  if (this.widgetType === 'wm-carousel') {
      this.hasBinding = true;
    }
    this.currentStep.activeLayout = this.selectedLiveWidgetLayout = layout;
    processLiveWidgetTemplate(layout.template, this);

  }

  selectWidgetNavigation(navType: any) {
    this.liveWidgetNavigation.selectedNavigation = navType;
  }

  setGridTemplates(val: any) {
    this.gridOptions.isEditable = val;
    this.selectWidgetLayout(find(this.liveWidgetLayouts, {id: (val === 'true' || val === true ? (this.variableFilter && this.variableFilter.category === 'wm.Variable' ? 'editable-grid' : ((this.variableFilter && this.variableFilter.category === 'wm.CrudVariable' && this.gridOptions.canEdit) || (get(this.widgetFilter, 'variable.category') === 'wm.CrudVariable' && this.gridOptions.canEdit) ? 'crud-grid-form-dialog' : 'grid-form-dialog')) : 'readonly-grid')}))
  }




  onStepChange(stepCount: number, isDecrement: boolean = false) {
    let prevStep = this.steps[stepCount - 1],
      liveListTemplate,
      templateObj: any;

    this.currentStep = this.steps[stepCount];
    this.message = undefined;
    if (stepCount < this.steps.length) {
      this.nextBtnText = stepCount === (this.steps.length - 1) ? this.locale.LABEL_DONE : this.locale.LABEL_NEXT;
      //Active widget is set to dropped widget or to the configured widget within live widget
      this.activeLiveWidget = (this.widgetType === 'wm-list' && this.stepCounter > 1) || (this.widgetType === 'wm-livetable' && this.stepCounter > 0) || (this.widgetType === 'wm-table' && this.stepCounter > 1) ? this.currentStep.liveWidgetId : this.widgetType;
      //Get description of steps for steps
      if ((['selectDataSource', 'templateConfig'].includes(this.currentStep.screen)) || this.steps.length === 1) {
        this.stepDescription = this.locale[this.currentStep.description];
      }

    }
    /* If previous step found, perform computations on previous steps.
     * the UI for previous step will be replaced with next step, hence respective controller will be destroyed
     * so, for prev step, required computations are done and configs persisted before controller is lost
     */
    if (prevStep && !isDecrement) {
      liveListTemplate = this.selectedLiveWidgetLayout?.template;
      templateObj = "" + liveListTemplate;
      let parsedTemplateObj = new DOMParser().parseFromString(templateObj, 'text/html');
      let listEle = parsedTemplateObj.querySelector("wm-list");
      switch (prevStep.screen) {
        case 'templateConfig':
          if (this.widgetType === 'wm-carousel' || this.steps[0].dynamicWidget) {
            this.setLiveWidgetTemplate(prevStep);
          }
          break;

      }
    }

    /* if final step reached, submit the configurations */
    if (stepCount >= this.steps.length) {
      if (!this.submitInProgress) {
        this.submitInProgress = true;
        this.onSubmit();
      }
      return;
    }
    if(this.currentStep.screen==='templateConfig'){
          this.initLiveWidgetLayoutDependencies();
    }

    this.showWizard = this.steps.length > 1;
  }

  onClose(): void {
    this.handleClose.emit();
  }

  setLiveWidgetTemplate(prevStep: any) {
    let widgetTemplate,
      templateObj: any;
    let templateEl = document.createElement("null");
    if (this.widgetType === 'wm-carousel') {
      widgetTemplate = this.widgetDetails.activeLayout.template;
      templateObj = $('<div>' + widgetTemplate + "</div>");

    }
    this.widgetDefs.template = templateObj[0].innerHTML;
  }

  onSubmit(): void {
    this.widgetDetails.templateEl = $(this.widgetDefs.template);
    this.widgetDetails.template = this.widgetDefs.template;
    this.handleComplete.emit({widgetDefs: this.widgetDefs, widgetDetails: this.widgetDetails});
  }
  //
  initLiveWidgetLayoutDependencies() {
    let layout,
      defaultLayout;
    this.liveWidgetLayouts = [...this.currentStep.templates];
    /* select active layout */

        defaultLayout = this.liveWidgetLayouts[0];
      layout = this.currentStep.activeLayout || defaultLayout;

    this.selectWidgetLayout(layout);
  }

  selectTemplateWidget(widget: any) {
    this.selectedWidget = widget;
  };
}
